import { Widgets } from "./Widgets";

export class SimpleNavigate extends Widgets{
    constructor(selector) {
        super(selector);
        this.simpleNavigate();
    }
}
 